import { render, staticRenderFns } from "./StatisticsOrderDetails.vue?vue&type=template&id=02bc499b&scoped=true"
import script from "./StatisticsOrderDetails.vue?vue&type=script&lang=js"
export * from "./StatisticsOrderDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02bc499b",
  null
  
)

export default component.exports